export default [
  {
    path: '/users',
    name: 'users',
    // eslint-disable-next-line import/no-unresolved
    component: () => import('@/views/user/UsersList.vue'),
    meta: {
      redirectIfLoggedIn: true,
      pageTitle: 'Khách hàng',
      breadcrumb: [
        {
          text: 'Danh sách khách hàng',
          active: true,
        },
      ],
    },
  },
  {
    path: '/users/create',
    name: 'users-create',
    // eslint-disable-next-line import/no-unresolved
    component: () => import('@/views/user/UserEdit.vue'),
    meta: {
      redirectIfLoggedIn: true,
      pageTitle: 'Khách hàng',
      breadcrumb: [
        {
          text: 'Danh sách khách hàng',
          to: { name: 'users' },
        },
        {
          text: 'Tạo mới người dùng',
          active: true,
        },
      ],
    },
  },
  {
    path: '/users/edit/:id',
    name: 'users-edit',
    // eslint-disable-next-line import/no-unresolved
    component: () => import('@/views/user/UserEdit.vue'),
    props: true,
    meta: {
      redirectIfLoggedIn: true,
      pageTitle: 'Khách hàng',
      breadcrumb: [
        {
          text: 'Danh sách khách hàng',
          to: { name: 'users' },
        },
        {
          text: 'Chỉnh sửa',
          active: true,
        },
      ],
    },
  },
  {
    path: '/users/group',
    name: 'users-group',
    // eslint-disable-next-line import/no-unresolved
    component: () => import('@/views/user/UserGroupsList.vue'),
    meta: {
      redirectIfLoggedIn: true,
      pageTitle: 'Nhóm Khách hàng',
      breadcrumb: [
        {
          text: 'Nhóm khách hàng',
          active: true,
        },
      ],
    },
  },
  {
    path: '/users/group/create',
    name: 'users-group-create',
    // eslint-disable-next-line import/no-unresolved
    component: () => import('@/views/user/UserGroupCreate.vue'),
    meta: {
      redirectIfLoggedIn: true,
      pageTitle: 'Nhóm Khách hàng',
      breadcrumb: [
        {
          text: 'Danh sách Nhóm Khách Hàng',
          to: { name: 'users-group' },
        },
        {
          text: 'Tạo Nhóm Mới',
          active: true,
        },
      ],
    },
  },
  {
    path: '/users/group/edit/:id',
    name: 'users-group-edit',
    // eslint-disable-next-line import/no-unresolved
    component: () => import('@/views/user/UserGroupEdit.vue'),
    meta: {
      redirectIfLoggedIn: true,
      pageTitle: 'Nhóm Khách hàng',
      breadcrumb: [
        {
          text: 'Danh sách Nhóm Khách Hàng',
          to: { name: 'users-group' },
        },
        {
          text: 'Chỉnh sửa',
          active: true,
        },
      ],
    },
  },
  {
    path: '/profile',
    name: 'profile',
    // eslint-disable-next-line import/no-unresolved
    component: () => import('@/views/Profile.vue'),
    meta: {
      redirectIfLoggedIn: true,
      pageTitle: 'Thông Tin Tài Khoản',
      breadcrumb: [
        {
          text: 'Chỉnh sửa',
          active: true,
        },
      ],
    },
  },
  {
    path: '/appointment-all',
    name: 'appointment-all',
    // eslint-disable-next-line import/no-unresolved
    component: () => import('@/views/appointment/all.vue'),
    meta: {
      redirectIfLoggedIn: true,
      pageTitle: 'Tất Cả Cuộc Hẹn',
      breadcrumb: [
        {
          text: 'Danh Sách Cuộc Hẹn',
          active: true,
        },
      ],
    },
  },
  {
    path: '/appointment-today',
    name: 'appointment-today',
    // eslint-disable-next-line import/no-unresolved
    component: () => import('@/views/appointment/today.vue'),
    meta: {
      redirectIfLoggedIn: true,
      pageTitle: 'Tất Cả Cuộc Hẹn Hôm Nay',
      breadcrumb: [
        {
          text: 'Danh Sách Cuộc Hẹn Hôm Nay',
          active: true,
        },
      ],
    },
  },
]
